import ScoreBadge from '../../components/ScoreBadge.jsx';
import PanelLoadMore from './PanelLoadMore.jsx';
// T270(6) — the on-demand dismissed list.
// T081 — Dismissed panel. Renders the list of dismissed recs with an
// Un-dismiss button per row + the operator's reason if one was captured
// at dismissal time (T070). Collapsed by default; the toggle button
// in the Available section header opens it.
export default function DismissedPanel({ recs, loaded, onUndismiss, hasMore, loadingMore, onLoadMore, total }) {
  return (
    <section className="mt-8">
      <h2 className="text-xs uppercase tracking-wide text-slate-500">
        Dismissed
        <span className="ml-2 text-slate-600">({total || recs.length})</span>
      </h2>
      {!loaded ? (
        <p className="mt-3 text-xs text-slate-500">Loading…</p>
      ) : recs.length === 0 ? (
        <p className="mt-3 text-xs text-slate-500">No dismissed recommendations.</p>
      ) : (
        <>
          <ul className="mt-3 divide-y divide-slate-800 rounded-xl border border-slate-800 bg-slate-900/30">
            {recs.map((r) => (
              <li key={r.id} className="flex flex-wrap items-baseline justify-between gap-3 px-4 py-3 text-sm">
                <div className="min-w-0 flex-1">
                  <p className="truncate">
                    <a
                      href={r.job?.url}
                      target="_blank"
                      rel="noreferrer"
                      className="font-medium text-slate-200 hover:text-brand-400"
                    >
                      {r.job?.title ?? '(no title)'}
                    </a>
                    <span className="text-slate-500"> @ {r.job?.company ?? '?'}</span>
                  </p>
                  {r.dismissedReason && (
                    <p className="mt-0.5 text-xs text-slate-500">
                      reason: <em>{r.dismissedReason}</em>
                    </p>
                  )}
                </div>
                <ScoreBadge
                  score={r.scoreTotal}
                  breakdown={r.scoreBreakdown}
                  reasons={r.reasons}
                  risks={r.risks}
                  missingSkills={r.missingSkills}
                  variant="compact"
                />
                <button
                  type="button"
                  onClick={() => onUndismiss(r.id)}
                  className="rounded-md border border-slate-700 px-2.5 py-1 text-xs text-slate-300 hover:border-brand-600 hover:text-brand-400"
                >
                  Un-dismiss
                </button>
              </li>
            ))}
          </ul>
          <PanelLoadMore
            shown={recs.length}
            total={total || recs.length}
            hasMore={hasMore}
            loading={loadingMore}
            onLoadMore={onLoadMore}
          />
        </>
      )}
    </section>
  );
}
